export default "__VITE_ASSET__290617ed__"